import { query, where, orderBy, limit } from 'firebase/firestore';
export class SubsetQuery {
    _query;
    constructor(query) {
        this._query = query;
    }
    where(prop, op, value) {
        this._query = query(this._query, where(prop, op, value));
        return this;
    }
    orderBy(prop, order = "asc") {
        this._query = query(this._query, orderBy(prop, order));
        return this;
    }
    limit(count) {
        this._query = query(this._query, limit(count));
        return this;
    }
    toQuery() {
        return this._query;
    }
}
//# sourceMappingURL=subset-query.js.map